import React, { createContext, useState, ReactNode, useEffect } from 'react';

interface AuthData {
  user: any;
  token: any | null;
  roleId: any | null;
  permissions: any[] | null;
}

export interface AuthContextProps {
  [x: string]: any;
  authData: AuthData;
  setAuthData: (data: AuthData) => void;
  isAuthenticated: boolean;   // ✅ ADD
  user: any | null;
}

export const AuthContext = createContext<AuthContextProps>({
  authData: { token: null, roleId: null, user: null, permissions: [] },
  setAuthData: () => { },
  isAuthenticated: false,     // ✅ ADD
  user: null,
});

export const AuthProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [authData, setAuthDataState] = useState<AuthData>(() => {
    try {
      const storedAuthData = localStorage.getItem('authData');
      if (storedAuthData && storedAuthData !== "undefined") {
        const parsed = JSON.parse(storedAuthData);
        if (parsed && typeof parsed === 'object') {
          return parsed;
        }
      }
    } catch (error) {
      console.error("Error parsing authData from localStorage:", error);
    }
    return { token: null, roleId: null, user: null, permissions: [] };
  });

  const setAuthData = (data: AuthData) => {
    setAuthDataState(data);
    localStorage.setItem('authData', JSON.stringify(data));
  };

  const isAuthenticated = !!authData?.token;
  const user = authData?.user;

  useEffect(() => {
    return () => {
      localStorage.removeItem('authData');
    };
  }, []);

  return (
    <AuthContext.Provider value={{ authData, setAuthData, isAuthenticated, user }}>
      {children}
    </AuthContext.Provider>
  );
};